var React = require('react');

function CheckboxDropdown (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.5","y":"0.5","width":"17","height":"17","stroke":"#1A237E"}));
}

CheckboxDropdown.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CheckboxDropdown;

CheckboxDropdown.default = CheckboxDropdown;
